import moment from 'moment'

export default {
    computed: {
        currentDateTime() {
            return new moment().format('DD/MM/YYYY')
        }
    },
    methods: {
        getInvoiceNumber: (num) => {
            return num.toString().padStart(6, "0")
        },
        getCurrentDateTime: function(){
            return new moment().format('YYYY-MM-DD HH:mm:ss')
        },
        getCurrentDate: function(){
            return new moment().format('YYYY-MM-DD')
        },
        getFormatDate: function(val){
            return new moment(val).format('YYYY-MM-DD')
        },
        getPreventDate: function(){
            return new moment().subtract(1, 'day').format('YYYY-MM-DD');
        },
        getCurrentYear: function(){
            return new moment().format('YYYY');
        },
        handleError(err) {
            return new Promise((resolve, reject) => {
                if (err.request) {
                    return reject(err);
                }
                switch (err.response.status) {
                    case 401:
                        this.$router.replace("/login");
                        return resolve("error handled");
                    case 403:
                        this.$swal({
                            type: "error",
                            title: "Permission Denied",
                            text: err.response
                                ? err.response.data
                                : "ທ່ານບໍ່ໄດ້ຮັບອະນຸຍາດໃຫ້ເຂົ້າ"
                        });
                        return resolve("error handled");
                    case 404:
                        this.$swal({
                            type: "error",
                            title: "Not Found",
                            text: err.response ? err.response.data : "Not Found"
                        });
                        return resolve("error handled");
                    default:
                        reject(err);
                }
            });
        },
        onInputNumber(e) {
            const charCode = e.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                e.preventDefault();
            } else {
                return true;
            }
        },
    },
    filters: {
        formatDayAndMonth: function(val){
            return new moment(val).format('DD/MM')
        },
        formatEuDate: function(val){
            return new moment(val).utc().format('DD/MM/YYYY')
        },
        formatDateTime: function(val){
            return new moment(val).format('YYYY-MM-DD HH:mm:ss')
        },
        formatMoney(
            // amount
            number
        ) {
            if (number === 0) return 0;
            return Number(number).toLocaleString("lo-LA", {
                minimumFractionDigits: 0,
            });
            /*const intFormat = baseFormat.slice(0, -3);
            const formattedNumber =
                intFormat.split(",").join(".") +
                baseFormat.substr(baseFormat.length - 3).replace(".", ",");
            return formattedNumber;*/
        },
        formatCardNumber: function (cardnumber) {
            if (!cardnumber) return ''
            return cardnumber.substr(0, 4) + '-' + cardnumber.substr(4, 4) + '-' + cardnumber.substr(8, 4) + '-' + cardnumber.substr(12)
        },
        formatAccountNumber(accountnumber) {
            return accountnumber.substr(0, 3) + '-' + accountnumber.substr(3, 2) + '-' + accountnumber.substr(5, 2) + '-' + accountnumber.substr(7, 8) + '-' + accountnumber.substr(15)
        },
        formTypeName(type) {
            if (type === 'NEWCARD') {
                return 'ອອກບັດໃໝ່'
            }
            if (type === 'REPIN') {
                return 'ອອກລະຫັດໃ​ໝ່'
            }
            if (type === 'ACCMOD') {
                return 'ປ່ຽນແປງເລກບັນຊີ'
            }
            return type
        },
        formatNumberLocal(number) {
            return isNaN(parseFloat(number)) ? '0' : parseFloat(number).toLocaleString('de-DE')
        },
        laoNumberString(n) {
            let leveltext = ['', 'ສິບ', 'ຮ້ອຍ', 'ພັນ', 'ໝື່ນ', 'ແສນ']
            let numtext = ['', 'ໜຶ່ງ', 'ສອງ', 'ສາມ', 'ສີ່', 'ຫ້າ', 'ຫົກ', 'ເຈັດ', 'ແປດ', 'ເກົ້າ']

            let res = ''

            let num = n + ''
            let et = false
            for (let i = 0; i < num.length; i++) {
                let val = parseInt(num.substr(i, 1))
                let pos = num.length - i - 1
                if (val > 0) {
                    if (val === 1 && pos % leveltext.length === 1) {
                        res += 'ສິບ'
                    } else if (val === 2 && pos % leveltext.length === 1) {
                        res += 'ຊາວ'
                    } else if (val === 1 && pos % leveltext.length === 0 && et) {
                        res += 'ເອັດ'
                    } else {
                        res += numtext[val] + leveltext[pos % leveltext.length]
                        et = false
                    }
                }
                if (pos % leveltext.length === 0 && pos > 0) {
                    res += 'ລ້ານ'
                }
                if (val !== 0 && pos % leveltext.length === 1) {
                    et = true
                }
            }
            return res ? res : '-'
        }
    }
}
